import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Allowed special characters; keep in sync with storage-service PasswordPolicy.ALLOWED_SPECIALS */
export const ALLOWED_PASSWORD_SPECIALS = '!@#$%^&*()_+-=[]{}|;:,.<>?/';

/** User-facing text; keep in sync with storage-service PasswordPolicy.USER_MESSAGE */
export const PASSWORD_POLICY_HINT =
  'Password must be at least 8 characters long and include an uppercase character, a number, and a special character';

function hasAllowedSpecial(s: string): boolean {
  for (const c of s) {
    if (ALLOWED_PASSWORD_SPECIALS.includes(c)) {
      return true;
    }
  }
  return false;
}

/** Matches backend: min 8, ≥1 A–Z, ≥1 digit, ≥1 character from ALLOWED_PASSWORD_SPECIALS. */
export function passwordPolicyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (v == null || v === '') {
      return null;
    }
    const s = String(v);
    if (s.length >= 8 && /[A-Z]/.test(s) && /[0-9]/.test(s) && hasAllowedSpecial(s)) {
      return null;
    }
    return { passwordPolicy: true };
  };
}
